import { SHARED_APPLICATIONS, SHARED_MODALS } from '../core';
import TeamApp from './apps/_team/app';
import ConsoleApp from './apps/_console/app';
import { SelectTagsModal, SelectGeoLocationTagsModal } from './modals';
import { ProjectViewModal } from './modals/projectViewModal';
import { CompetitionBravoModal } from './modals/competitionBravoModal';
import { CompetitionBravoErrorModal } from './modals/competitionBravoErrorModal';
import { CompetitionLegalsModal } from './modals/competitionLegalsModal/competitionLegalsModal';
import { PaidWithFormParticipateModal } from './modals/PaidWithFormParticipateModal/PaidWithFormParticipateModal';
import { SendProjectModal } from './modals/sendProjects/SendProjectModal';
import { FeedbackForm } from './components/feedbackForm';
import { ReportForm } from './components/reportForm';
import { NotSavedDataModal } from './modals/notSavedData/notSavedData';
import { SelectChapters } from './modals/selectChapters/SelectChapters';
import { LegalsModal } from "./modals/legalsModal";
import { SelectShortList } from './modals/selectShortList/SelectShortList';
import {SendProjectForEmploy} from "./modals/sendProjects/SendProjectForEmploy";
import {ShareModal} from "./modals/ShareModal/ShareModal";
import { TransferProjectStep1Modal, TransferProjectLinkModal } from "./modals/TransferProjectModal";
import { ExportProjectsModal } from "./modals/ExportProjectsModal";
import { ImportProjectModal, ImportProjectSuccessModal } from "./modals/ImportProjectModal";
import TermsOfUseModal from './modals/TermsOfUseModal';
import NotificationList from "./components/NotificationsController/NotificationList";
import {     
    ArtzLegalsModal,
    ErrorModal,
    SuccessModal,
    LoadingModal } from './modals/artzLegalsModal';
import GroupModal from './modals/groups';
import {SendBrndItemModal} from "./modals/sendProjects/SendBrndItemModal";
import {SendImagesModal} from "./modals/sendProjects/SendImagesModal";
import {ScheduleModal} from "./modals/scheduleModal/scheduleModal";
import {CheckHomeworkModal} from './modals/checkHomeworkModal/checkHomeworkModal';
import {PreviewerModal} from "./modals/previewerModal/previewerModal";
import {SendProjectLongreadModal} from "./modals/sendProjects/SendProjectLongreadModal";
import PaymentError from "./features/QueuePaymenrt/payment/PaymentError";
import PaymentSuccess from "./features/QueuePaymenrt/payment/PaymentSuccess";
import PaymentManager from "./features/QueuePaymenrt/payment/PaymentManager";
import { SendProjectToCompetition } from './modals/sendProjects/SendProjectToCompetition';
import {BookPaymentSuccess} from "./features/QueuePaymenrt/components/BookPaymentSuccess/BookPaymentSuccess";
import TopUpBalance from './features/QueuePaymenrt/payment/TopUpBalance';
import { AgeRestrictionModal } from "./modals/AgeRestrictionModal/AgeRestrictionModal";
import { CustomLegalsModal } from './modals/customLegalsModal/customLegalsModal';
import { ProjectPublishModal } from './modals/projectPublishModal/ProjectPublishModal';
import { PaymentErrorModal } from './modals/PaymentErrorModal';
import { SortingModal } from './modals/SortingModal/SortingModal';
import {TeamSubscribe} from "./modals/TeamSubscribe/TeamSubscribe";
import { CustomInfoModal } from './modals/CustomInfoModal/CustomInfoModal';
import {SelectContextModalNew} from "./modals/selectContextModalNew";
import { CreateTagModal } from './modals/selectTagsModal/components/CreateTagComponent/CreateTagModal';
import {CodeViewerModal} from "./modals/CodeViewerModal/CodeViewerModal";
import { LockDataModal } from './modals/lockDataModal/LockDataModal';
import { FoldersProjectsEdit } from './modals/FolderModal';
import ProductsSelectModal from './modals/CardSelectModal/ProductsSelectModal';
import ReproductionSelectModal from './modals/CardSelectModal/ReproductionSelectModal';
import { ConfirmDeleteCoverModal } from './modals/confirmCoverDeleteModal';
import { SubscribeUserModal } from './modals/subscribeUser/SubscribeUserModal';
import { FormDropdownEdit } from './modals/formDropdownEdit/FormDropdownEdit';
import {ApplicationFormTemplate} from "./modals/ApplicationFormTemplate/applicationFormTemplate";
import { TagDescriptionModal } from './modals/TagDescriptionModal/TagDescriptionModal';
import { RepostModal } from './modals/repostModal/RepostModal';
import { TemplateModal } from './modals/TemplateModal/TemplateModal';
import { ConfirmCourseCompletionModal } from './modals/ConfirmCourseCompletion';
import CollectionsSelectModal from './modals/CardSelectModal/CollectionsSelectModal';
import CalendarsSelectModal from './modals/CardSelectModal/CalendarsSelectModal';
import { FormulaEditor } from './pages/projectEdit/components/PresentatitonBlock/FormulaEditor';
import { AccessModal } from './modals/AccessModal/AccessModal';
import { ConfirmationModal } from './modals/ConfirmationModal/ConfirmationModal';
import { PresentationModeModal } from './modals/PresentationModeModal';
import { RetakeModal } from './modals/RetakeModal/RetakeModal';
import ExternalShowcasesEditModal from './pages/teams/components/ExternalShowcasesEditModal';

import PaymentUnavailableModal from './modals/PaymentUnavailableModal/PaymentUnavailableModal';
import SendConfirmation from './modals/SendConfirmation/SendConfirmation';
import CompetitionProjectSent from './modals/CompetitionProjectSent/CompetitionProjectSent';
import { LessonAddModal } from './modals/LessonAddModal/LessonAddModal';
import { ConsultationLessonModal } from './modals/ConsultationLessonModal/ConsultationLessonModal';
import { ConsultationRecordsModal } from './modals/ConsultationRecordsModal/ConsultationRecordsModal';
import { ConsultationRegistrationModal } from './modals/ConsultationRegistrationModal/ConsultationRegistrationModal';
import { LessonDeleteModal } from './modals/LessonDeleteModal/LessonDeleteModal';
import { LessonCreateModal } from './modals/LessonCreateModal/LessonCreateModal';
import { LessonTypeSelectModal } from './modals/LessonTypeSelectModal/LessonTypeSelectModal';
import { RegularLessonModal } from './modals/RegularLessonModal/RegularLessonModal';
import { CourseCardPurchaseModal } from './modals/CourseCardPurchaseModal/CourseCardPurchaseModal';
import TestCreateModal from './modals/testCreate/TestCreateModal';
import TestSelectDraftModal from './modals/testSelectDraft/TestSelectDraftModal';
import { LongreadTestResultsModal } from './modals/longreadTestResults/LongreadTestResultsModal';
import { TeachingEvaluationCampaignModal } from './modals/TeachingEvaluationCampaignModal/TeachingEvaluationCampaignModal';
import { TeachingEvaluationCompleteModal } from './modals/TeachingEvaluationCompleteModal/TeachingEvaluationCompleteModal';
import { TeamFormCopyModal } from './pages/teams/components/TeamFormCopyModal';
import { TeamFormModal } from './modals/teamFormModal/TeamFormModal';
import { ShopApplicationModal } from './modals/shopApplicationModal/ShopApplicationModal';
import ApplicationEditor from './modals/ApplicationEditor/ApplicationEditor';
import { EditLockedByAuthorFrame } from './components/error-frames';
import { TeamTabProjectsOrderModal } from './modals/teamTabProjectsOrder/TeamTabProjectsOrderModal';
import { ConfirmCourseActionModal } from './modals/ConfirmCourseActionModal';
import { DeleteTeamGroupModal } from './modals/DeleteTeamGroupModal';
import { FtblJoinClubModal } from './modals/FtblJoinClubModal';
import AddPhotoControl from './components/AddPhotoControl';
import {
    ChooseAkiStatusRefuseConfirmModal,
    ChooseAkiStatusRefusedModal,
    ChooseAkiStatusSuccessModal,
} from './modals/chooseAkiStatus';
import MoveCompetitionsModal from './modals/MoveCompetitionsModal/MoveCompetitionsModal';
import CompetitionEditFolderModal from './modals/CompetitionEditFolderModal/CompetitionEditFolderModal';
import AddPhotoControlNew from './components/AddPhotoControl';
import { MagistracyPortfolioModal } from './modals/magistracyPortfolio/MagistracyPortfolioModal';
import { MagistracyApplicationSuccessModal } from './modals/magistracyApplication/MagistracyApplicationSuccessModal';
import { EnrollCourseModal } from './modals/EnrollCourseModal';
import { FormCourseSuccessModal } from './modals/FormCourseSuccessModal';
import { AddGroupTeachersModal } from './modals/AddGroupTeachersModal';
import { StatusesAdminModal } from './modals/StatusesAdminModal/StatusesAdminModal';
import { HeadCommentModal } from './modals/HeadCommentModal';
import { PracticModal } from './modals/PracticModal';
import { captureUtm } from './helpers/utm';

export const setupApp = (): void => {
    captureUtm();

    SHARED_APPLICATIONS['team'] = TeamApp;
    SHARED_APPLICATIONS['console'] = ConsoleApp;

    SHARED_MODALS['confirmDeleteCoverModal'] = {
        closable: true,
        component: ConfirmDeleteCoverModal,
        closeLeft: true,
        customFillBackgroundColor: 'rgba(0,0,0,0.20)'
        
    };
    SHARED_MODALS['context-new'] = {
        closable: true,
        component: SelectContextModalNew,
        solidBackground: true,
        closeLeft: true,
    };
    SHARED_MODALS['favorites-modal'] = {
        component: SelectContextModalNew,
        headerVisibleMobile: true,
        bottomOffset: 123,
        customFillBackgroundColor: '#E7E7E7',
        hideCloseOnMobile: true,
        customZIndex: 2001,
    };
    SHARED_MODALS['notifications'] = {
        closable: false,
        component: NotificationList,
        solidBackground: true,
        closeLeft: false,
        headerVisibleMobile: true,
        containerId: "notification-dropdown",
    };
    SHARED_MODALS['subscribe-user'] = {
        closable: false,
        component: SubscribeUserModal,
        customFillBackgroundColor: 'rgba(0,0,0,0.65)'
    }
    SHARED_MODALS['template-modal'] = {
        closable: false,
        component: TemplateModal,
        customFillBackgroundColor: '#FEFEFE'
    }
    SHARED_MODALS['repost-into-channel'] = {
        closable: false,
        component: RepostModal,
        customFillBackgroundColor: 'rgba(0,0,0,0.65)'
    }
    SHARED_MODALS['head-comment'] = {
        closable: false,
        component: HeadCommentModal,
        customFillBackgroundColor: 'rgba(0,0,0,0.65)',
        shadowClosableBackground: true,
    }

    SHARED_MODALS['form-dropdown-edit'] = {
        closable: false,
        component: FormDropdownEdit,
        customFillBackgroundColor: 'rgba(0,0,0,0.65)'
    }
    SHARED_MODALS['external-showcases-edit'] = {
        closable: false,
        component: ExternalShowcasesEditModal,
        customFillBackgroundColor: 'rgba(0,0,0,0.65)'
    }
    SHARED_MODALS['team-form-copy'] = {
        closable: false,
        component: TeamFormCopyModal,
        customFillBackgroundColor: 'rgba(0,0,0,0.65)'
    }
    SHARED_MODALS['team-form-modal'] = {
        closable: true,
        component: TeamFormModal,
        solidBackground: true,
    }
    SHARED_MODALS['shop-application-modal'] = {
        closable: true,
        component: ShopApplicationModal,
        customFillBackgroundColor: 'rgba(0,0,0,0.65)'
    }
    // SHARED_MODALS['template-modal'] = {
    //     closable: false,
    //     component: TemplateModal,
    //     customFillBackgroundColor: 'rgba(0,0,0,0.65)'
    // }
    SHARED_MODALS['project'] = {
        closable: true,
        component: ProjectViewModal,
        solidBackground: false,
        closeLeft: true,
    };
    SHARED_MODALS['competition-sent'] = {
        closable: false,
        component: CompetitionBravoModal,
        solidBackground: true,
        closeLeft: true,
    };
    SHARED_MODALS['competition-sent-error'] = {
        closable: false,
        component: CompetitionBravoErrorModal,
        solidBackground: true,
        closeLeft: true,
    };
    SHARED_MODALS['shop-sent'] = {
        closable: false,
        component: SendBrndItemModal,
        solidBackground: true,
        closeLeft: true,
    };
    SHARED_MODALS['image-sent'] = {
        closable: true,
        component: SendImagesModal,
        solidBackground: true,
        closeLeft: true,
    };
    SHARED_MODALS['sent-to-competition'] = {
        closable: true,
        component: SendProjectToCompetition,
        solidBackground: true,
        closeLeft: true,
        importantBlack: true,
        mobileVersion: true,
        hideCloseOnMobile: true
    };
    SHARED_MODALS['geolocation-tags'] = {
        closable: false,
        component: SelectGeoLocationTagsModal,
        solidBackground: true,
        closeLeft: true,
        hideCloseOnMobile: true,
    };
    SHARED_MODALS['project-products'] = {
        closable: true,
        component: ProductsSelectModal,
        solidBackground: true,
        // hideCloseOnMobile: true,
    };
    SHARED_MODALS['project-reproductions'] = {
        closable: true,
        component: ReproductionSelectModal,
        solidBackground: true,
        // hideCloseOnMobile: true,
    };
    SHARED_MODALS['project-collections'] = {
        closable: true,
        component: CollectionsSelectModal,
        solidBackground: true,
        // hideCloseOnMobile: true,
    };
    SHARED_MODALS['project-calendars'] = {
        closable: true,
        component: CalendarsSelectModal,
        solidBackground: true,
        // hideCloseOnMobile: true,
    };
    SHARED_MODALS['not-saved-data'] = {
        closable: false,
        component: NotSavedDataModal,
        closeLeft: true,
    };
    SHARED_MODALS['lock-data'] = {
        component: LockDataModal,
        solidBackground: true,
        customFillBackgroundColor: 'rgba(21, 21, 20, 0.64)'
    };
    SHARED_MODALS['lms-lock-data'] = {
        component: EditLockedByAuthorFrame,
        solidBackground: true,
        customFillBackgroundColor: 'rgb(232, 232, 232)',
        closable: false,
    };
    SHARED_MODALS['competition-form'] = {
        closable: true,
        component: CompetitionLegalsModal,
        solidBackground: true,
        closeLeft: true,
    };
    SHARED_MODALS['paid-with-form-participate'] = {
        closable: true,
        component: PaidWithFormParticipateModal,
        solidBackground: true,
    };
    SHARED_MODALS['code-viewer'] = {
        closable: true,
        component: CodeViewerModal,
        customHoverCloserColor: '#ffffff',
    };
    SHARED_MODALS['sorting-modal'] = {
        closable: true,
        component: SortingModal,
        solidBackground: true,
        hideCloseOnMobile: true,
        customFillBackgroundColor: 'rgba(255,255,255,0.6)'
    };
    SHARED_MODALS['project-publish'] = {
        component: ProjectPublishModal,
        customFillBackgroundColor: 'rgba(21,21,20,0.64)',
        customBackdropFilter: 'blur(12px)',
        shadowClosableBackground: true,
        mobileFlexEnd: true,
    };
    SHARED_MODALS['competition-custom-legals'] = {
        closable: true,
        component: CustomLegalsModal,
        solidBackground: true,
        closeLeft: true,
    };
    SHARED_MODALS['application-form'] = {
        closable: true,
        component: ApplicationFormTemplate,
        solidBackground: true,
        closeLeft: true,
    };
    SHARED_MODALS['custom-info-modal'] = {
        closable: true,
        component: CustomInfoModal,
        solidBackground: false,
    };
    SHARED_MODALS['send-project'] = {
        closable: true,
        // hideCloseOnMobile: true,
        component: SendProjectModal,
        solidBackground: true,
        headerVisibleMobile: true,
        // closeLeft: true,
    };
    SHARED_MODALS['send-project-longread'] = {
        closable: true,
        hideCloseOnMobile: true,
        component: SendProjectLongreadModal,
        solidBackground: true,
        headerVisibleMobile: true,
        closeLeft: true,
    };
    SHARED_MODALS['tag-description-edit'] = {
        closable: true,
        hideCloseOnMobile: true,
        component: TagDescriptionModal,
        solidBackground: true,
        headerVisibleMobile: true,
        closeLeft: true,
    };
    SHARED_MODALS['send-project-employ'] = {
        closable: true,
        hideCloseOnMobile: true,
        component: SendProjectForEmploy,
        solidBackground: true,
        headerVisibleMobile: true,
        mobileFlexStart: true,
        closeLeft: true,
    };
    SHARED_MODALS['group'] = {
        closable: true,
        hideCloseOnMobile: true,
        component: GroupModal,
        solidBackground: true,
        headerVisibleMobile: true,
        mobileFlexStart: true,
        closeLeft: true,
    };
    SHARED_MODALS['artz-legals'] = {
        mobileFlexStart: true,
        shadowClosableBackground: true,
        component: ArtzLegalsModal,
    };
    SHARED_MODALS['artz-legals-success'] = {
        shadowClosableBackground: true,
        component: SuccessModal,
    };
    SHARED_MODALS['access'] = {
        shadowClosableBackground: true,
        component: AccessModal,
    };
    SHARED_MODALS['confirmation'] = {
        shadowClosableBackground: true,
        component: ConfirmationModal,
    };
    SHARED_MODALS['artz-legals-error'] = {
        shadowClosableBackground: true,
        component: ErrorModal,
    };
    SHARED_MODALS['artz-legals-load'] = {
        shadowClosableBackground: true,
        component: LoadingModal,
    };
    SHARED_MODALS['share'] = {
        shadowClosableBackground: true,
        mobileFlexEnd: true,
        component: ShareModal,
    };

    SHARED_MODALS['transfer-project-step1'] = {
        shadowClosableBackground: true,
        mobileFlexEnd: true,
        component: TransferProjectStep1Modal,
    };

    SHARED_MODALS['transfer-project-link'] = {
        shadowClosableBackground: true,
        mobileFlexEnd: true,
        component: TransferProjectLinkModal,
    };

    SHARED_MODALS['export-projects'] = {
        shadowClosableBackground: true,
        mobileFlexEnd: true,
        component: ExportProjectsModal,
    };

    SHARED_MODALS['import-project'] = {
        shadowClosableBackground: true,
        mobileFlexEnd: true,
        component: ImportProjectModal,
    };

    SHARED_MODALS['import-project-success'] = {
        shadowClosableBackground: true,
        mobileFlexEnd: true,
        component: ImportProjectSuccessModal,
    };

    SHARED_MODALS['choose-aki-status-success'] = {
        closable: false,
        shadowClosableBackground: true,
        component: ChooseAkiStatusSuccessModal,
    };
    SHARED_MODALS['choose-aki-status-refuse-confirm'] = {
        closable: false,
        shadowClosableBackground: true,
        component: ChooseAkiStatusRefuseConfirmModal,
    };
    SHARED_MODALS['choose-aki-status-refused'] = {
        closable: false,
        shadowClosableBackground: true,
        component: ChooseAkiStatusRefusedModal,
    };

    SHARED_MODALS['team-tab-projects-order'] = {
        closable: false,
        solidBackground: true,
        fullscreen: true,
        component: TeamTabProjectsOrderModal,
    };

    SHARED_MODALS['folder-projects-edit'] = {
        // shadowClosableBackground: true,
        solidBackground: true,
        mobileFlexEnd: true,
        hideCloseOnMobile: true,
        component: FoldersProjectsEdit,
    };
    SHARED_MODALS['magistracy-portfolio'] = {
        closable: true,
        solidBackground: true,
        hideCloseOnMobile: true,
        mobileFlexEnd: true,
        component: MagistracyPortfolioModal,
    };
    SHARED_MODALS['magistracy-application-success'] = {
        closable: true,
        solidBackground: true,
        hideCloseOnMobile: true,
        mobileFlexEnd: true,
        component: MagistracyApplicationSuccessModal,
    };

    SHARED_MODALS['tags'] = {
        closable: true,
        component: SelectTagsModal,
        headerVisibleMobile: true,
        hideCloseOnMobile: true,
    };

    SHARED_MODALS['feedback'] = {
        closable: true,
        component: FeedbackForm,
    };

    SHARED_MODALS['report'] = {
        closable: true,
        component: ReportForm,
        mobileFlexStart: true,
        tabletFlexStart: true,
        hideCloseOnMobile: true,
        mobileSolidBackground: true,
        headerVisibleMobile: true,
    };

    SHARED_MODALS['select-chapters'] = {
        closable: true,
        component: SelectChapters,
        mobileVersion: true
    };

    SHARED_MODALS['select-short-list'] = {
        closable: true,
        component: SelectShortList,
        mobileVersion: true
    };

    SHARED_MODALS['legals'] = {
        closable: true,
        component: LegalsModal,
    };
    SHARED_MODALS['terms-of-use'] = {
        closable: true,
        solidBackground: false,
        fullscreen: true,
        component: TermsOfUseModal
    };
    SHARED_MODALS['schedule'] = {
        closable: true,
        solidBackground: false,
        fullscreen: true,
        component: ScheduleModal
    };
    SHARED_MODALS['lesson-add'] = {
        shadowClosableBackground: true,
        component: LessonAddModal,
    };
    SHARED_MODALS['lesson-type-select'] = {
        shadowClosableBackground: true,
        component: LessonTypeSelectModal,
    };
    SHARED_MODALS['regular-lesson'] = {
        shadowClosableBackground: true,
        component: RegularLessonModal,
    };
    SHARED_MODALS['consultation-lesson'] = {
        shadowClosableBackground: true,
        component: ConsultationLessonModal,
    };
    SHARED_MODALS['consultation-registration'] = {
        shadowClosableBackground: true,
        component: ConsultationRegistrationModal,
    };
    SHARED_MODALS['consultation-records'] = {
        shadowClosableBackground: true,
        component: ConsultationRecordsModal,
    };
    SHARED_MODALS['lesson-delete'] = {
        shadowClosableBackground: true,
        component: LessonDeleteModal,
    };
    SHARED_MODALS['lesson-create'] = {
        shadowClosableBackground: true,
        component: LessonCreateModal,
    };
    SHARED_MODALS['check-homework'] = {
        closable: true,
        solidBackground: false,
        fullscreen: true,
        component: CheckHomeworkModal
    };
    SHARED_MODALS['previewer'] = {
        closable: true,
        shadowClosableBackground: true,
        component: PreviewerModal,
        isPreviewer: true
    };
    SHARED_MODALS['paymentError'] = {
        closable: true,
        component: PaymentError,
        customFillBackgroundColor: 'rgb(232, 232, 232)'
    }
    SHARED_MODALS['paymentErrorModal'] = {
        closable: true,
        component: PaymentErrorModal,
    }

    SHARED_MODALS['paymentSuccess'] = {
        closable: true,
        component: PaymentSuccess,
        customFillBackgroundColor: 'rgb(232, 232, 232)'
    }

    SHARED_MODALS['paymentManager'] = {
        closable: true,
        component: PaymentManager,
        customFillBackgroundColor: 'rgb(232, 232, 232)'
    }
    SHARED_MODALS['course-card-purchase-modal'] = {
        closable: true,
        component: CourseCardPurchaseModal,
        customFillBackgroundColor: 'rgb(232, 232, 232)'
    }
    SHARED_MODALS['bookPaymentSuccess'] = {
        closable: true,
        component: BookPaymentSuccess,
        customFillBackgroundColor: 'rgb(232, 232, 232)'
    }
    SHARED_MODALS['topUpBalance'] = {
        closable: true,
        component: TopUpBalance,
        customFillBackgroundColor: 'rgb(232, 232, 232)'
    }
    SHARED_MODALS['ageRestricted'] = {
        closable: false,
        component: AgeRestrictionModal,
        customFillBackgroundColor: 'transparent'
    }
    SHARED_MODALS['paymentUnavailable'] = {
        closable: false,
        component: PaymentUnavailableModal,
        customFillBackgroundColor: 'transparent'
    }
    SHARED_MODALS['sendConfirmation'] = {
        closable: false,
        component: SendConfirmation,
        customFillBackgroundColor: 'transparent'
    }
    SHARED_MODALS['competitionProjectSent'] = {
        closable: true,
        component: CompetitionProjectSent,
        // customFillBackgroundColor: 'transparent'
    }
    SHARED_MODALS['createTag'] = {
        closable: true,
        component: CreateTagModal
    }
    SHARED_MODALS['teamSubscribe'] = {
        closable: false,
        component: TeamSubscribe,
        customFillBackgroundColor: 'transparent',
        shadowClosableBackground: true,
        shadowClosableBackgroundMobile: true,
    }
    SHARED_MODALS['ftblJoinClub'] = {
        closable: false,
        shadowClosableBackground: true,
        component: FtblJoinClubModal,
    }
    SHARED_MODALS['confirmCourseCompletionModal'] = {
        closable: true,
        component: ConfirmCourseCompletionModal,
        closeLeft: true,
        customFillBackgroundColor: 'rgba(0,0,0,0.20)'
    };
    SHARED_MODALS['confirmCourseActionModal'] = {
        closable: false,
        component: ConfirmCourseActionModal,
        customFillBackgroundColor: 'rgba(0,0,0,0.65)'
    };
    SHARED_MODALS['deleteTeamGroupModal'] = {
        closable: false,
        component: DeleteTeamGroupModal,
        customFillBackgroundColor: 'rgba(0,0,0,0.65)'
    };
    SHARED_MODALS['enroll-course'] = {
        closable: false,
        component: EnrollCourseModal,
        shadowClosableBackground: true,
        shadowClosableBackgroundMobile: true,
    };
    SHARED_MODALS['form-course-success'] = {
        closable: false,
        component: FormCourseSuccessModal,
        shadowClosableBackground: true,
        shadowClosableBackgroundMobile: true,
    };
    SHARED_MODALS['add-group-teachers'] = {
        closable: true,
        component: AddGroupTeachersModal,
        solidBackground: true,
        customZIndex: 2000000,
    };
     SHARED_MODALS['formula'] = {
        closable: true,
        component: FormulaEditor,
        headerVisibleMobile: true,
        hideCloseOnMobile: true,
    };
    SHARED_MODALS['presentation-mode'] = {
        closable: false,
        component: PresentationModeModal,
        fullscreen: true,
        solidBackground: false,
        customZIndex: 300000,
    };
    
    SHARED_MODALS['retake-modal'] = {
        closable: false,
        component: RetakeModal,
        customFillBackgroundColor: 'rgba(0,0,0,0.65)'
    };
    SHARED_MODALS['testCreate'] = {
        closable: true,
        component: TestCreateModal,
        solidBackground: true,
    };
    SHARED_MODALS['testSelectDraft'] = {
        closable: true,
        component: TestSelectDraftModal,
        solidBackground: true,
        mobileFlexStart: true,
        tabletFlexStart: true,
    };
    SHARED_MODALS['longread-test-results'] = {
        closable: true,
        component: LongreadTestResultsModal,
        solidBackground: true,
        mobileFlexStart: true,
        tabletFlexStart: true,
    };
    SHARED_MODALS['teaching-evaluation-campaign'] = {
        closable: false,
        component: TeachingEvaluationCampaignModal,
        fullscreen: true,
        solidBackground: true,
        tabletFlexStart: true,
        mobileFlexStart: true,
        customZIndex: 1000001,
    };
    SHARED_MODALS['teaching-evaluation-complete'] = {
        closable: false,
        component: TeachingEvaluationCompleteModal,
        fullscreen: true,
        solidBackground: true,
    };
    SHARED_MODALS['applicationEditor'] = {
        closable: true,
        component: ApplicationEditor,
        customFillBackgroundColor: '#343434',
        closeLeft: true,
    };
    SHARED_MODALS['add_photo'] = {
        component: AddPhotoControlNew,
        headerVisibleMobile: true,
        bottomOffset: 117,
        customFillBackgroundColor: '#E7E7E7',
        hideCloseOnMobile: true,
        mobileFlexStart: true,
        customZIndex: 999,
    };
    SHARED_MODALS['moveCompetitions'] = {
        closable: true,
        component: MoveCompetitionsModal,
        customFillBackgroundColor: '#343434',
        solidBackground: true,
        // closeLeft: true,
    };
    SHARED_MODALS['competition-edit-folder-modal'] = {
        closable: true,
        component: CompetitionEditFolderModal,
        customFillBackgroundColor: '#343434',
        solidBackground: true,
    };
    SHARED_MODALS['statuses-admin-modal'] = {
        closable: true,
        component: StatusesAdminModal,
        solidBackground: true,
    };
    SHARED_MODALS['practic-modal'] = {
        closable: false,
        component: PracticModal,
        shadowClosableBackground: true,
        shadowClosableBackgroundMobile: true,
    };
};
import { SHARED_APPLICATIONS, SHARED_MODALS } from '../core';
import TeamApp from './apps/_team/app';
import ConsoleApp from './apps/_console/app';
import { SelectTagsModal, SelectGeoLocationTagsModal } from './modals';
import { ProjectViewModal } from './modals/projectViewModal';
import { CompetitionBravoModal } from './modals/competitionBravoModal';
import { CompetitionBravoErrorModal } from './modals/competitionBravoErrorModal';
import { CompetitionLegalsModal } from './modals/competitionLegalsModal/competitionLegalsModal';
import { PaidWithFormParticipateModal } from './modals/PaidWithFormParticipateModal/PaidWithFormParticipateModal';
import { SendProjectModal } from './modals/sendProjects/SendProjectModal';
import { FeedbackForm } from './components/feedbackForm';
import { ReportForm } from './components/reportForm';
import { NotSavedDataModal } from './modals/notSavedData/notSavedData';
import { SelectChapters } from './modals/selectChapters/SelectChapters';
import { LegalsModal } from "./modals/legalsModal";
import { SelectShortList } from './modals/selectShortList/SelectShortList';
import {SendProjectForEmploy} from "./modals/sendProjects/SendProjectForEmploy";
import {ShareModal} from "./modals/ShareModal/ShareModal";
import { TransferProjectStep1Modal, TransferProjectLinkModal } from "./modals/TransferProjectModal";
import { ExportProjectsModal } from "./modals/ExportProjectsModal";
import { ImportProjectModal, ImportProjectSuccessModal } from "./modals/ImportProjectModal";
import TermsOfUseModal from './modals/TermsOfUseModal';
import NotificationList from "./components/NotificationsController/NotificationList";
import {     
    ArtzLegalsModal,
    ErrorModal,
    SuccessModal,
    LoadingModal } from './modals/artzLegalsModal';
import GroupModal from './modals/groups';
import {SendBrndItemModal} from "./modals/sendProjects/SendBrndItemModal";
import {SendImagesModal} from "./modals/sendProjects/SendImagesModal";
import {ScheduleModal} from "./modals/scheduleModal/scheduleModal";
import {CheckHomeworkModal} from './modals/checkHomeworkModal/checkHomeworkModal';
import {PreviewerModal} from "./modals/previewerModal/previewerModal";
import {SendProjectLongreadModal} from "./modals/sendProjects/SendProjectLongreadModal";
import PaymentError from "./features/QueuePaymenrt/payment/PaymentError";
import PaymentSuccess from "./features/QueuePaymenrt/payment/PaymentSuccess";
import PaymentManager from "./features/QueuePaymenrt/payment/PaymentManager";
import { SendProjectToCompetition } from './modals/sendProjects/SendProjectToCompetition';
import {BookPaymentSuccess} from "./features/QueuePaymenrt/components/BookPaymentSuccess/BookPaymentSuccess";
import TopUpBalance from './features/QueuePaymenrt/payment/TopUpBalance';
import { AgeRestrictionModal } from "./modals/AgeRestrictionModal/AgeRestrictionModal";
import { CustomLegalsModal } from './modals/customLegalsModal/customLegalsModal';
import { ProjectPublishModal } from './modals/projectPublishModal/ProjectPublishModal';
import { PaymentErrorModal } from './modals/PaymentErrorModal';
import { SortingModal } from './modals/SortingModal/SortingModal';
import {TeamSubscribe} from "./modals/TeamSubscribe/TeamSubscribe";
import { CustomInfoModal } from './modals/CustomInfoModal/CustomInfoModal';
import {SelectContextModalNew} from "./modals/selectContextModalNew";
import { CreateTagModal } from './modals/selectTagsModal/components/CreateTagComponent/CreateTagModal';
import {CodeViewerModal} from "./modals/CodeViewerModal/CodeViewerModal";
import { LockDataModal } from './modals/lockDataModal/LockDataModal';
import { FoldersProjectsEdit } from './modals/FolderModal';
import ProductsSelectModal from './modals/CardSelectModal/ProductsSelectModal';
import ReproductionSelectModal from './modals/CardSelectModal/ReproductionSelectModal';
import { ConfirmDeleteCoverModal } from './modals/confirmCoverDeleteModal';
import { SubscribeUserModal } from './modals/subscribeUser/SubscribeUserModal';
import { FormDropdownEdit } from './modals/formDropdownEdit/FormDropdownEdit';
import {ApplicationFormTemplate} from "./modals/ApplicationFormTemplate/applicationFormTemplate";
import { TagDescriptionModal } from './modals/TagDescriptionModal/TagDescriptionModal';
import { RepostModal } from './modals/repostModal/RepostModal';
import { TemplateModal } from './modals/TemplateModal/TemplateModal';
import { ConfirmCourseCompletionModal } from './modals/ConfirmCourseCompletion';
import CollectionsSelectModal from './modals/CardSelectModal/CollectionsSelectModal';
import CalendarsSelectModal from './modals/CardSelectModal/CalendarsSelectModal';
import { FormulaEditor } from './pages/projectEdit/components/PresentatitonBlock/FormulaEditor';
import { AccessModal } from './modals/AccessModal/AccessModal';
import { ConfirmationModal } from './modals/ConfirmationModal/ConfirmationModal';
import { PresentationModeModal } from './modals/PresentationModeModal';
import { RetakeModal } from './modals/RetakeModal/RetakeModal';
import ExternalShowcasesEditModal from './pages/teams/components/ExternalShowcasesEditModal';

import PaymentUnavailableModal from './modals/PaymentUnavailableModal/PaymentUnavailableModal';
import SendConfirmation from './modals/SendConfirmation/SendConfirmation';
import CompetitionProjectSent from './modals/CompetitionProjectSent/CompetitionProjectSent';
import { LessonAddModal } from './modals/LessonAddModal/LessonAddModal';
import { ConsultationLessonModal } from './modals/ConsultationLessonModal/ConsultationLessonModal';
import { ConsultationRecordsModal } from './modals/ConsultationRecordsModal/ConsultationRecordsModal';
import { ConsultationRegistrationModal } from './modals/ConsultationRegistrationModal/ConsultationRegistrationModal';
import { LessonDeleteModal } from './modals/LessonDeleteModal/LessonDeleteModal';
import { LessonCreateModal } from './modals/LessonCreateModal/LessonCreateModal';
import { LessonTypeSelectModal } from './modals/LessonTypeSelectModal/LessonTypeSelectModal';
import { RegularLessonModal } from './modals/RegularLessonModal/RegularLessonModal';
import { CourseCardPurchaseModal } from './modals/CourseCardPurchaseModal/CourseCardPurchaseModal';
import TestCreateModal from './modals/testCreate/TestCreateModal';
import TestSelectDraftModal from './modals/testSelectDraft/TestSelectDraftModal';
import { LongreadTestResultsModal } from './modals/longreadTestResults/LongreadTestResultsModal';
import { TeachingEvaluationCampaignModal } from './modals/TeachingEvaluationCampaignModal/TeachingEvaluationCampaignModal';
import { TeachingEvaluationCompleteModal } from './modals/TeachingEvaluationCompleteModal/TeachingEvaluationCompleteModal';
import { TeamFormCopyModal } from './pages/teams/components/TeamFormCopyModal';
import { TeamFormModal } from './modals/teamFormModal/TeamFormModal';
import { ShopApplicationModal } from './modals/shopApplicationModal/ShopApplicationModal';
import ApplicationEditor from './modals/ApplicationEditor/ApplicationEditor';
import { EditLockedByAuthorFrame } from './components/error-frames';
import { TeamTabProjectsOrderModal } from './modals/teamTabProjectsOrder/TeamTabProjectsOrderModal';
import { ConfirmCourseActionModal } from './modals/ConfirmCourseActionModal';
import { DeleteTeamGroupModal } from './modals/DeleteTeamGroupModal';
import { FtblJoinClubModal } from './modals/FtblJoinClubModal';
import AddPhotoControl from './components/AddPhotoControl';
import {
    ChooseAkiStatusRefuseConfirmModal,
    ChooseAkiStatusRefusedModal,
    ChooseAkiStatusSuccessModal,
} from './modals/chooseAkiStatus';
import MoveCompetitionsModal from './modals/MoveCompetitionsModal/MoveCompetitionsModal';
import CompetitionEditFolderModal from './modals/CompetitionEditFolderModal/CompetitionEditFolderModal';
import AddPhotoControlNew from './components/AddPhotoControl';
import { MagistracyPortfolioModal } from './modals/magistracyPortfolio/MagistracyPortfolioModal';
import { MagistracyApplicationSuccessModal } from './modals/magistracyApplication/MagistracyApplicationSuccessModal';
import { EnrollCourseModal } from './modals/EnrollCourseModal';
import { FormCourseSuccessModal } from './modals/FormCourseSuccessModal';
import { AddGroupTeachersModal } from './modals/AddGroupTeachersModal';
import { StatusesAdminModal } from './modals/StatusesAdminModal/StatusesAdminModal';
import { HeadCommentModal } from './modals/HeadCommentModal';
import { PracticModal } from './modals/PracticModal';
import { captureUtm } from './helpers/utm';

export const setupApp = (): void => {
    captureUtm();

    SHARED_APPLICATIONS['team'] = TeamApp;
    SHARED_APPLICATIONS['console'] = ConsoleApp;

    SHARED_MODALS['confirmDeleteCoverModal'] = {
        closable: true,
        component: ConfirmDeleteCoverModal,
        closeLeft: true,
        customFillBackgroundColor: 'rgba(0,0,0,0.20)'
        
    };
    SHARED_MODALS['context-new'] = {
        closable: true,
        component: SelectContextModalNew,
        solidBackground: true,
        closeLeft: true,
    };
    SHARED_MODALS['favorites-modal'] = {
        component: SelectContextModalNew,
        headerVisibleMobile: true,
        bottomOffset: 123,
        customFillBackgroundColor: '#E7E7E7',
        hideCloseOnMobile: true,
        customZIndex: 2001,
    };
    SHARED_MODALS['notifications'] = {
        closable: false,
        component: NotificationList,
        solidBackground: true,
        closeLeft: false,
        headerVisibleMobile: true,
        containerId: "notification-dropdown",
    };
    SHARED_MODALS['subscribe-user'] = {
        closable: false,
        component: SubscribeUserModal,
        customFillBackgroundColor: 'rgba(0,0,0,0.65)'
    }
    SHARED_MODALS['template-modal'] = {
        closable: false,
        component: TemplateModal,
        customFillBackgroundColor: '#FEFEFE'
    }
    SHARED_MODALS['repost-into-channel'] = {
        closable: false,
        component: RepostModal,
        customFillBackgroundColor: 'rgba(0,0,0,0.65)'
    }
    SHARED_MODALS['head-comment'] = {
        closable: false,
        component: HeadCommentModal,
        customFillBackgroundColor: 'rgba(0,0,0,0.65)',
        shadowClosableBackground: true,
    }

    SHARED_MODALS['form-dropdown-edit'] = {
        closable: false,
        component: FormDropdownEdit,
        customFillBackgroundColor: 'rgba(0,0,0,0.65)'
    }
    SHARED_MODALS['external-showcases-edit'] = {
        closable: false,
        component: ExternalShowcasesEditModal,
        customFillBackgroundColor: 'rgba(0,0,0,0.65)'
    }
    SHARED_MODALS['team-form-copy'] = {
        closable: false,
        component: TeamFormCopyModal,
        customFillBackgroundColor: 'rgba(0,0,0,0.65)'
    }
    SHARED_MODALS['team-form-modal'] = {
        closable: true,
        component: TeamFormModal,
        solidBackground: true,
    }
    SHARED_MODALS['shop-application-modal'] = {
        closable: true,
        component: ShopApplicationModal,
        customFillBackgroundColor: 'rgba(0,0,0,0.65)'
    }
    // SHARED_MODALS['template-modal'] = {
    //     closable: false,
    //     component: TemplateModal,
    //     customFillBackgroundColor: 'rgba(0,0,0,0.65)'
    // }
    SHARED_MODALS['project'] = {
        closable: true,
        component: ProjectViewModal,
        solidBackground: false,
        closeLeft: true,
    };
    SHARED_MODALS['competition-sent'] = {
        closable: false,
        component: CompetitionBravoModal,
        solidBackground: true,
        closeLeft: true,
    };
    SHARED_MODALS['competition-sent-error'] = {
        closable: false,
        component: CompetitionBravoErrorModal,
        solidBackground: true,
        closeLeft: true,
    };
    SHARED_MODALS['shop-sent'] = {
        closable: false,
        component: SendBrndItemModal,
        solidBackground: true,
        closeLeft: true,
    };
    SHARED_MODALS['image-sent'] = {
        closable: true,
        component: SendImagesModal,
        solidBackground: true,
        closeLeft: true,
    };
    SHARED_MODALS['sent-to-competition'] = {
        closable: true,
        component: SendProjectToCompetition,
        solidBackground: true,
        closeLeft: true,
        importantBlack: true,
        mobileVersion: true,
        hideCloseOnMobile: true
    };
    SHARED_MODALS['geolocation-tags'] = {
        closable: false,
        component: SelectGeoLocationTagsModal,
        solidBackground: true,
        closeLeft: true,
        hideCloseOnMobile: true,
    };
    SHARED_MODALS['project-products'] = {
        closable: true,
        component: ProductsSelectModal,
        solidBackground: true,
        // hideCloseOnMobile: true,
    };
    SHARED_MODALS['project-reproductions'] = {
        closable: true,
        component: ReproductionSelectModal,
        solidBackground: true,
        // hideCloseOnMobile: true,
    };
    SHARED_MODALS['project-collections'] = {
        closable: true,
        component: CollectionsSelectModal,
        solidBackground: true,
        // hideCloseOnMobile: true,
    };
    SHARED_MODALS['project-calendars'] = {
        closable: true,
        component: CalendarsSelectModal,
        solidBackground: true,
        // hideCloseOnMobile: true,
    };
    SHARED_MODALS['not-saved-data'] = {
        closable: false,
        component: NotSavedDataModal,
        closeLeft: true,
    };
    SHARED_MODALS['lock-data'] = {
        component: LockDataModal,
        solidBackground: true,
        customFillBackgroundColor: 'rgba(21, 21, 20, 0.64)'
    };
    SHARED_MODALS['lms-lock-data'] = {
        component: EditLockedByAuthorFrame,
        solidBackground: true,
        customFillBackgroundColor: 'rgb(232, 232, 232)',
        closable: false,
    };
    SHARED_MODALS['competition-form'] = {
        closable: true,
        component: CompetitionLegalsModal,
        solidBackground: true,
        closeLeft: true,
    };
    SHARED_MODALS['paid-with-form-participate'] = {
        closable: true,
        component: PaidWithFormParticipateModal,
        solidBackground: true,
    };
    SHARED_MODALS['code-viewer'] = {
        closable: true,
        component: CodeViewerModal,
        customHoverCloserColor: '#ffffff',
    };
    SHARED_MODALS['sorting-modal'] = {
        closable: true,
        component: SortingModal,
        solidBackground: true,
        hideCloseOnMobile: true,
        customFillBackgroundColor: 'rgba(255,255,255,0.6)'
    };
    SHARED_MODALS['project-publish'] = {
        component: ProjectPublishModal,
        customFillBackgroundColor: 'rgba(21,21,20,0.64)',
        customBackdropFilter: 'blur(12px)',
        shadowClosableBackground: true,
        mobileFlexEnd: true,
    };
    SHARED_MODALS['competition-custom-legals'] = {
        closable: true,
        component: CustomLegalsModal,
        solidBackground: true,
        closeLeft: true,
    };
    SHARED_MODALS['application-form'] = {
        closable: true,
        component: ApplicationFormTemplate,
        solidBackground: true,
        closeLeft: true,
    };
    SHARED_MODALS['custom-info-modal'] = {
        closable: true,
        component: CustomInfoModal,
        solidBackground: false,
    };
    SHARED_MODALS['send-project'] = {
        closable: true,
        // hideCloseOnMobile: true,
        component: SendProjectModal,
        solidBackground: true,
        headerVisibleMobile: true,
        // closeLeft: true,
    };
    SHARED_MODALS['send-project-longread'] = {
        closable: true,
        hideCloseOnMobile: true,
        component: SendProjectLongreadModal,
        solidBackground: true,
        headerVisibleMobile: true,
        closeLeft: true,
    };
    SHARED_MODALS['tag-description-edit'] = {
        closable: true,
        hideCloseOnMobile: true,
        component: TagDescriptionModal,
        solidBackground: true,
        headerVisibleMobile: true,
        closeLeft: true,
    };
    SHARED_MODALS['send-project-employ'] = {
        closable: true,
        hideCloseOnMobile: true,
        component: SendProjectForEmploy,
        solidBackground: true,
        headerVisibleMobile: true,
        mobileFlexStart: true,
        closeLeft: true,
    };
    SHARED_MODALS['group'] = {
        closable: true,
        hideCloseOnMobile: true,
        component: GroupModal,
        solidBackground: true,
        headerVisibleMobile: true,
        mobileFlexStart: true,
        closeLeft: true,
    };
    SHARED_MODALS['artz-legals'] = {
        mobileFlexStart: true,
        shadowClosableBackground: true,
        component: ArtzLegalsModal,
    };
    SHARED_MODALS['artz-legals-success'] = {
        shadowClosableBackground: true,
        component: SuccessModal,
    };
    SHARED_MODALS['access'] = {
        shadowClosableBackground: true,
        component: AccessModal,
    };
    SHARED_MODALS['confirmation'] = {
        shadowClosableBackground: true,
        component: ConfirmationModal,
    };
    SHARED_MODALS['artz-legals-error'] = {
        shadowClosableBackground: true,
        component: ErrorModal,
    };
    SHARED_MODALS['artz-legals-load'] = {
        shadowClosableBackground: true,
        component: LoadingModal,
    };
    SHARED_MODALS['share'] = {
        shadowClosableBackground: true,
        mobileFlexEnd: true,
        component: ShareModal,
    };

    SHARED_MODALS['transfer-project-step1'] = {
        shadowClosableBackground: true,
        mobileFlexEnd: true,
        component: TransferProjectStep1Modal,
    };

    SHARED_MODALS['transfer-project-link'] = {
        shadowClosableBackground: true,
        mobileFlexEnd: true,
        component: TransferProjectLinkModal,
    };

    SHARED_MODALS['export-projects'] = {
        shadowClosableBackground: true,
        mobileFlexEnd: true,
        component: ExportProjectsModal,
    };

    SHARED_MODALS['import-project'] = {
        shadowClosableBackground: true,
        mobileFlexEnd: true,
        component: ImportProjectModal,
    };

    SHARED_MODALS['import-project-success'] = {
        shadowClosableBackground: true,
        mobileFlexEnd: true,
        component: ImportProjectSuccessModal,
    };

    SHARED_MODALS['choose-aki-status-success'] = {
        closable: false,
        shadowClosableBackground: true,
        component: ChooseAkiStatusSuccessModal,
    };
    SHARED_MODALS['choose-aki-status-refuse-confirm'] = {
        closable: false,
        shadowClosableBackground: true,
        component: ChooseAkiStatusRefuseConfirmModal,
    };
    SHARED_MODALS['choose-aki-status-refused'] = {
        closable: false,
        shadowClosableBackground: true,
        component: ChooseAkiStatusRefusedModal,
    };

    SHARED_MODALS['team-tab-projects-order'] = {
        closable: false,
        solidBackground: true,
        fullscreen: true,
        component: TeamTabProjectsOrderModal,
    };

    SHARED_MODALS['folder-projects-edit'] = {
        // shadowClosableBackground: true,
        solidBackground: true,
        mobileFlexEnd: true,
        hideCloseOnMobile: true,
        component: FoldersProjectsEdit,
    };
    SHARED_MODALS['magistracy-portfolio'] = {
        closable: true,
        solidBackground: true,
        hideCloseOnMobile: true,
        mobileFlexEnd: true,
        component: MagistracyPortfolioModal,
    };
    SHARED_MODALS['magistracy-application-success'] = {
        closable: true,
        solidBackground: true,
        hideCloseOnMobile: true,
        mobileFlexEnd: true,
        component: MagistracyApplicationSuccessModal,
    };

    SHARED_MODALS['tags'] = {
        closable: true,
        component: SelectTagsModal,
        headerVisibleMobile: true,
        hideCloseOnMobile: true,
    };

    SHARED_MODALS['feedback'] = {
        closable: true,
        component: FeedbackForm,
    };

    SHARED_MODALS['report'] = {
        closable: true,
        component: ReportForm,
        mobileFlexStart: true,
        tabletFlexStart: true,
        hideCloseOnMobile: true,
        mobileSolidBackground: true,
        headerVisibleMobile: true,
    };

    SHARED_MODALS['select-chapters'] = {
        closable: true,
        component: SelectChapters,
        mobileVersion: true
    };

    SHARED_MODALS['select-short-list'] = {
        closable: true,
        component: SelectShortList,
        mobileVersion: true
    };

    SHARED_MODALS['legals'] = {
        closable: true,
        component: LegalsModal,
    };
    SHARED_MODALS['terms-of-use'] = {
        closable: true,
        solidBackground: false,
        fullscreen: true,
        component: TermsOfUseModal
    };
    SHARED_MODALS['schedule'] = {
        closable: true,
        solidBackground: false,
        fullscreen: true,
        component: ScheduleModal
    };
    SHARED_MODALS['lesson-add'] = {
        shadowClosableBackground: true,
        component: LessonAddModal,
    };
    SHARED_MODALS['lesson-type-select'] = {
        shadowClosableBackground: true,
        component: LessonTypeSelectModal,
    };
    SHARED_MODALS['regular-lesson'] = {
        shadowClosableBackground: true,
        component: RegularLessonModal,
    };
    SHARED_MODALS['consultation-lesson'] = {
        shadowClosableBackground: true,
        component: ConsultationLessonModal,
    };
    SHARED_MODALS['consultation-registration'] = {
        shadowClosableBackground: true,
        component: ConsultationRegistrationModal,
    };
    SHARED_MODALS['consultation-records'] = {
        shadowClosableBackground: true,
        component: ConsultationRecordsModal,
    };
    SHARED_MODALS['lesson-delete'] = {
        shadowClosableBackground: true,
        component: LessonDeleteModal,
    };
    SHARED_MODALS['lesson-create'] = {
        shadowClosableBackground: true,
        component: LessonCreateModal,
    };
    SHARED_MODALS['check-homework'] = {
        closable: true,
        solidBackground: false,
        fullscreen: true,
        component: CheckHomeworkModal
    };
    SHARED_MODALS['previewer'] = {
        closable: true,
        shadowClosableBackground: true,
        component: PreviewerModal,
        isPreviewer: true
    };
    SHARED_MODALS['paymentError'] = {
        closable: true,
        component: PaymentError,
        customFillBackgroundColor: 'rgb(232, 232, 232)'
    }
    SHARED_MODALS['paymentErrorModal'] = {
        closable: true,
        component: PaymentErrorModal,
    }

    SHARED_MODALS['paymentSuccess'] = {
        closable: true,
        component: PaymentSuccess,
        customFillBackgroundColor: 'rgb(232, 232, 232)'
    }

    SHARED_MODALS['paymentManager'] = {
        closable: true,
        component: PaymentManager,
        customFillBackgroundColor: 'rgb(232, 232, 232)'
    }
    SHARED_MODALS['course-card-purchase-modal'] = {
        closable: true,
        component: CourseCardPurchaseModal,
        customFillBackgroundColor: 'rgb(232, 232, 232)'
    }
    SHARED_MODALS['bookPaymentSuccess'] = {
        closable: true,
        component: BookPaymentSuccess,
        customFillBackgroundColor: 'rgb(232, 232, 232)'
    }
    SHARED_MODALS['topUpBalance'] = {
        closable: true,
        component: TopUpBalance,
        customFillBackgroundColor: 'rgb(232, 232, 232)'
    }
    SHARED_MODALS['ageRestricted'] = {
        closable: false,
        component: AgeRestrictionModal,
        customFillBackgroundColor: 'transparent'
    }
    SHARED_MODALS['paymentUnavailable'] = {
        closable: false,
        component: PaymentUnavailableModal,
        customFillBackgroundColor: 'transparent'
    }
    SHARED_MODALS['sendConfirmation'] = {
        closable: false,
        component: SendConfirmation,
        customFillBackgroundColor: 'transparent'
    }
    SHARED_MODALS['competitionProjectSent'] = {
        closable: true,
        component: CompetitionProjectSent,
        // customFillBackgroundColor: 'transparent'
    }
    SHARED_MODALS['createTag'] = {
        closable: true,
        component: CreateTagModal
    }
    SHARED_MODALS['teamSubscribe'] = {
        closable: false,
        component: TeamSubscribe,
        customFillBackgroundColor: 'transparent',
        shadowClosableBackground: true,
        shadowClosableBackgroundMobile: true,
    }
    SHARED_MODALS['ftblJoinClub'] = {
        closable: false,
        shadowClosableBackground: true,
        component: FtblJoinClubModal,
    }
    SHARED_MODALS['confirmCourseCompletionModal'] = {
        closable: true,
        component: ConfirmCourseCompletionModal,
        closeLeft: true,
        customFillBackgroundColor: 'rgba(0,0,0,0.20)'
    };
    SHARED_MODALS['confirmCourseActionModal'] = {
        closable: false,
        component: ConfirmCourseActionModal,
        customFillBackgroundColor: 'rgba(0,0,0,0.65)'
    };
    SHARED_MODALS['deleteTeamGroupModal'] = {
        closable: false,
        component: DeleteTeamGroupModal,
        customFillBackgroundColor: 'rgba(0,0,0,0.65)'
    };
    SHARED_MODALS['enroll-course'] = {
        closable: false,
        component: EnrollCourseModal,
        shadowClosableBackground: true,
        shadowClosableBackgroundMobile: true,
    };
    SHARED_MODALS['form-course-success'] = {
        closable: false,
        component: FormCourseSuccessModal,
        shadowClosableBackground: true,
        shadowClosableBackgroundMobile: true,
    };
    SHARED_MODALS['add-group-teachers'] = {
        closable: true,
        component: AddGroupTeachersModal,
        solidBackground: true,
        customZIndex: 2000000,
    };
     SHARED_MODALS['formula'] = {
        closable: true,
        component: FormulaEditor,
        headerVisibleMobile: true,
        hideCloseOnMobile: true,
    };
    SHARED_MODALS['presentation-mode'] = {
        closable: false,
        component: PresentationModeModal,
        fullscreen: true,
        solidBackground: false,
        customZIndex: 300000,
    };
    
    SHARED_MODALS['retake-modal'] = {
        closable: false,
        component: RetakeModal,
        customFillBackgroundColor: 'rgba(0,0,0,0.65)'
    };
    SHARED_MODALS['testCreate'] = {
        closable: true,
        component: TestCreateModal,
        solidBackground: true,
    };
    SHARED_MODALS['testSelectDraft'] = {
        closable: true,
        component: TestSelectDraftModal,
        solidBackground: true,
        mobileFlexStart: true,
        tabletFlexStart: true,
    };
    SHARED_MODALS['longread-test-results'] = {
        closable: true,
        component: LongreadTestResultsModal,
        solidBackground: true,
        mobileFlexStart: true,
        tabletFlexStart: true,
    };
    SHARED_MODALS['teaching-evaluation-campaign'] = {
        closable: false,
        component: TeachingEvaluationCampaignModal,
        fullscreen: true,
        solidBackground: true,
        tabletFlexStart: true,
        mobileFlexStart: true,
        customZIndex: 1000001,
    };
    SHARED_MODALS['teaching-evaluation-complete'] = {
        closable: false,
        component: TeachingEvaluationCompleteModal,
        fullscreen: true,
        solidBackground: true,
    };
    SHARED_MODALS['applicationEditor'] = {
        closable: true,
        component: ApplicationEditor,
        customFillBackgroundColor: '#343434',
        closeLeft: true,
    };
    SHARED_MODALS['add_photo'] = {
        component: AddPhotoControlNew,
        headerVisibleMobile: true,
        bottomOffset: 117,
        customFillBackgroundColor: '#E7E7E7',
        hideCloseOnMobile: true,
        mobileFlexStart: true,
        customZIndex: 999,
    };
    SHARED_MODALS['moveCompetitions'] = {
        closable: true,
        component: MoveCompetitionsModal,
        customFillBackgroundColor: '#343434',
        solidBackground: true,
        // closeLeft: true,
    };
    SHARED_MODALS['competition-edit-folder-modal'] = {
        closable: true,
        component: CompetitionEditFolderModal,
        customFillBackgroundColor: '#343434',
        solidBackground: true,
    };
    SHARED_MODALS['statuses-admin-modal'] = {
        closable: true,
        component: StatusesAdminModal,
        solidBackground: true,
    };
    SHARED_MODALS['practic-modal'] = {
        closable: false,
        component: PracticModal,
        shadowClosableBackground: true,
        shadowClosableBackgroundMobile: true,
    };
};
